import type { PageHeaderTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

export const pageHeaderDark: PageHeaderTheme = {
  name: 'PageHeader',
  common: commonDark,
  self
}
